import React, { Component } from 'react';
import Slider from 'react-slick';
import language from '../../../assets/languages/language';
import { getIpAddress } from '../../../common/getIpAddress';
import appRoutes from '../../../routes/exams/gmat-focus/app-routes';
import ModalComponent from '../../Common/Modal';
import GMATSubscriptionCheck from '../../RestAPI/GMATFocusSubscription';
import PartnerGMATSubscriptionCheck from '../../RestAPI/PartnerSubscription/GMATFocusSubscription';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import AlertMessage from '../../config/alertMessage';
import './VideoLessons.css';
import { flowPlayerVideoLessonUrl } from '../../../common/constant';
/* eslint-disable*/

class ChatperwiseReadingData extends Component {
  constructor(props) {
    super(props);
    var messageTitle_cfa = `<i class="icon-info icons font-2xl d-block "></i>`;
    this.state = {
      allchapters: [],
      offset: 0,
      limit: 10,
      alert_status: false,
      MessageTitle: messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_gmat,
      chapters: [],
      allChapters: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      Allchapters: [],
      itemData: [],
      videoUrl: '',
      srcUrl: '',
      srcUrl_final: '',
      selectedmenu: 'gmat_focus',
      showFreePremium: true,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert = () => {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  };

  goPremium = () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  _getReadings = async (chapter, index) => {
    // const result = getDeviceDetails();
    await this.savelastVideo(chapter, index);
    if (chapter.free === 1) {
      const data = {
        token: this.state.token,
        idname: this.state.idname,
        id: chapter.id,
        videoIndex: index,
        city: this.state.user_city,
        country: this.state.user_country,
        state: this.state.user_state,
        continent: this.state.user_continent,
        ip: this.state.user_ip,
      };
      FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/trackUserVideowatch', data).then(
        async resp => {
          if (resp.success) {
            this.context.router.push({
              pathname: appRoutes.VIDEO_DISPLAY.replace(':id', chapter.id)
                .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
                .replace(':type', chapter.chapter_id === 0 ? 0 : 1)
                .replace(':chapter_id', chapter.chapter_id)
                .replace(':index', index),
            });
          } else {
          }
        },
      );
    } else {
      // console.log('inside else fdsfdsfdsfsd34 dfsdsfdfs dsfdfsdfs');

      const data = { token: this.state.token, idname: this.state.idname };
      FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });

            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATVideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  if (isInArray_var) {
                    const data = {
                      token: this.state.token,
                      idname: this.state.idname,
                      id: chapter.id,
                      videoIndex: index,
                      city: this.state.user_city,
                      country: this.state.user_country,
                      state: this.state.user_state,
                      continent: this.state.user_continent,
                      ip: this.state.user_ip,
                    };
                    FD.callAPI(
                      App_data.backend_api + '/gmat-focus/question-bank/trackUserVideowatch',
                      data,
                    ).then(async resp => {
                      if (resp.success) {
                        this.context.router.push({
                          pathname: appRoutes.VIDEO_DISPLAY.replace(':id', chapter.id)
                            .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
                            .replace(':type', chapter.chapter_id === 0 ? 0 : 1)
                            .replace(':chapter_id', chapter.chapter_id)
                            .replace(':index', index),
                        });
                      } else {
                      }
                    });
                  } else {
                    this.toggleAlert();
                  }
                } else {
                }
              },
            );
          }
        } else {
          // console.log('heyyyyyyyyyyyyyy===============');
          if (
            resp.profileInfo.exam_selected === '' &&
            resp.profileInfo.cfaUnlimitedPackage == '' &&
            resp.profileInfo.cfaUnlimitedActiveExam == ''
          ) {
            // console.log('aaaaaaaaaaaaaaaa');
            return this.toggleAlert();
          } else {
            // console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbbbb');
            var exam_selected = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : resp.profileInfo.exam_selected;
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });
            // console.log('else working');
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              resp_exam => {
                // console.log(
                //   resp_exam,
                //   '00000000000000000000000000000000000000000'
                // );
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = GMATSubscriptionCheck.checkGMATVideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  // console.log(isInArray_var, selectedmen, exam_data);
                  if (isInArray_var) {
                    // console.log('IF WORKING');

                    const data = {
                      token: this.state.token,
                      idname: this.state.idname,
                      id: chapter.id,
                      videoIndex: index,
                      city: this.state.user_city,
                      country: this.state.user_country,
                      state: this.state.user_state,
                      continent: this.state.user_continent,
                      ip: this.state.user_ip,
                    };
                    FD.callAPI(
                      App_data.backend_api + '/gmat-focus/question-bank/trackUserVideowatch',
                      data,
                    ).then(async resp => {
                      if (resp.success) {
                        this.context.router.push({
                          pathname: appRoutes.VIDEO_DISPLAY.replace(':id', chapter.id)
                            .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
                            .replace(':type', chapter.chapter_id === 0 ? 0 : 1)
                            .replace(':chapter_id', chapter.chapter_id)
                            .replace(':index', index),
                        });
                      } else {
                      }
                    });
                  } else {
                    // console.log('ELSE WORKING')
                    return this.toggleAlert();
                  }
                } else {
                  // console.log('fail');
                }
              },
            );
          }
        }
      });
    }
  };

  savelastVideo = async (chapter, index) => {
    const { token, idname } = this.state;
    var data_data = {
      token: token,
      idname: idname,
      video_id: chapter.id,
      videoIndex: index,
    };
    await FD.callAPI(
      App_data.backend_api + '/gmat-focus/question-bank/saveLastViewedVideo',
      data_data,
    ).then(response => {
      if (response.success) {
        this.setState({
          ValidToken: true,
        });
      }
    });
  };

  iframe = {
    padding: 10,
  };

  async componentDidMount() {
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    this.setState({ showFreePremium: this.props.showFreePremium });
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    let dataCW = {
      token: storage_session['token'],
      chapter_id: this.props.item.chapter_no,
    };
    await FD.callAPI(
      App_data.backend_api + '/gmat-focus/question-bank/getGMATVideosChapterwise',
      dataCW,
    ).then(resp => {
      if (resp.success) {
        // console.log(resp);
        this.setState({ allchapters: resp.cfavchapter });
      } else {
        this.setState({ allchapters: [] });
        this.setState({ ValidToken: false });
      }
    });
  }

  videoSection = () => {
    var domainApp = localStorage.getItem('domainApp');
    let data = '';

    if (this.state.allchapters.length) {
      let count = 0;
      data = this.state.allchapters.map((item, index) => {
        // let videoUrl = item.url.split("/");
        // let srcUrl_final = (videoUrl[4].split("?"))[0];
        return (
          <div key={index}>
            {/* <div> {item.free}</div> */}
            {this.state.showFreePremium ? (
              item.free === 1 ? (
                <div className='video-type-free'>{language.LC().FREE}</div>
              ) : (
                <div className='video-type-primum'>{language.LC().PREMIUM}</div>
              )
            ) : (
              <div />
            )}
            {item.url_id_qq ? (
              <img
                alt=''
                width='100%'
                src={
                  item.posterImage
                    ? item.posterImage
                    : flowPlayerVideoLessonUrl(`${item.url_id_qq}-1`)
                }
                onError={({ currentTarget }) => {
                  if (!count++) {
                    // Added condition because of infinite loop, this will once only
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = flowPlayerVideoLessonUrl(`${item.url_id_qq}-1_2`);
                  }
                }}
                value={index}
                onClick={this._getReadings.bind(this, item, index)}
                className='pointer_class slider_row'
              />
            ) : (
              <img
                width='100%'
                src={`https://img.youtube.com/vi/${item.url_id}/mqdefault.jpg`}
                value={index}
                onClick={this._getReadings.bind(this, item, index)}
                className='pointer_class slider_row'
              />
            )}

            <strong style={{ padding: '10px' }}> {item.title}</strong>
          </div>
        );
      });
    } else {
      return null;
    }
    return data;
  };

  render() {
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          },
        },
      ],
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
    return (
      <div>
        <Slider {...settings}>{this.videoSection()}</Slider>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
      </div>
    );
  }
}
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <img onClick={onClick} src='../../assets/img/right-arrow.svg' alt='' />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        fontSize: '60px',
        right: '80px',
        zIndex: '15',
        height: '20px',
        width: '40px',
        opacity: '1',
      }}
      onClick={onClick}
    >
      <img onClick={onClick} src='../../assets/img/left-arrow.svg' alt='' />
    </div>
  );
}
export default ChatperwiseReadingData;



// WEBPACK FOOTER //
// ./src/views/GMATFocus/VideoLessons/ChatperwiseReadingData.js